import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';

export const stylesThemeMui = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    premiumColor: {
      color: theme.color.premium.main,
    },
  });

export const useStyles = makeStyles((theme: Theme) => ({
  premiumColor: {
    color: theme.color.premium.main,
  },
}));
